import messages from '../../resources/messages/lang'

export const getLocalizedValue = (locale, key) => {
  return messages[locale][key]
}